/* Publish by EComposer at 2026-11-03 13:47:07*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qfzxlu64t2g"]=  window.__ectimmers["ecom-qfzxlu64t2g"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-qfzxlu64t2g').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qfzxlu64t2g', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qfzxlu64t2g', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-o1zqodyjimc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-o1zqodyjimc', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-o1zqodyjimc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qrvlwhkob9p').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qrvlwhkob9p', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qrvlwhkob9p', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-a77twhbp6kg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a77twhbp6kg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a77twhbp6kg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-te5yuzqh0i9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-te5yuzqh0i9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-te5yuzqh0i9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-k7gs9j9jky').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-k7gs9j9jky', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-k7gs9j9jky', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rmybemi2eie').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rmybemi2eie', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rmybemi2eie', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1kk2izl5b9u').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1kk2izl5b9u', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1kk2izl5b9u', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oxkxku8gzrf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oxkxku8gzrf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oxkxku8gzrf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3lpb83qi549').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3lpb83qi549', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3lpb83qi549', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5obvazxlzok').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5obvazxlzok', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5obvazxlzok', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qkprnh4f6be').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qkprnh4f6be', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qkprnh4f6be', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-iz6f18bil5e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-iz6f18bil5e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-iz6f18bil5e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kyygaobjlcl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kyygaobjlcl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kyygaobjlcl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-f7h8f7zhru4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-f7h8f7zhru4', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-f7h8f7zhru4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p7pa8e3fteh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p7pa8e3fteh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p7pa8e3fteh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-db4z4sehz4s').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-db4z4sehz4s', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-db4z4sehz4s', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-82u9zol1kwi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-82u9zol1kwi', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-82u9zol1kwi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-bz6zsq4oweq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-bz6zsq4oweq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-bz6zsq4oweq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-csdn0o52djw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-csdn0o52djw', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-csdn0o52djw', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ftquoambnw8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ftquoambnw8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ftquoambnw8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gu8w7j342wa').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gu8w7j342wa', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gu8w7j342wa', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-921ob1vuvht').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-921ob1vuvht', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-921ob1vuvht', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oqds1gfpea').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oqds1gfpea', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oqds1gfpea', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oa5xq39gkc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oa5xq39gkc', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oa5xq39gkc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-j1rv3wml2a').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-j1rv3wml2a', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-j1rv3wml2a', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kbg3zfzhf2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kbg3zfzhf2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kbg3zfzhf2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yis6uuodk2h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yis6uuodk2h', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yis6uuodk2h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-41p4pmxo6uo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-41p4pmxo6uo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-41p4pmxo6uo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-j8e850gzp7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-j8e850gzp7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-j8e850gzp7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-s8gbrddn6tb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-s8gbrddn6tb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-s8gbrddn6tb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4nh0qztme8s').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4nh0qztme8s', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4nh0qztme8s', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nh4bpomvc5f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nh4bpomvc5f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nh4bpomvc5f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ar9cd3y1t5e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ar9cd3y1t5e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ar9cd3y1t5e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8w0mitxyuf4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8w0mitxyuf4', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8w0mitxyuf4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-561ycoxxwca').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-561ycoxxwca', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-561ycoxxwca', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vpbclfe9iv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vpbclfe9iv', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vpbclfe9iv', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-n1dser08ira').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-n1dser08ira', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-n1dser08ira', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8v8vqcf1tll').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8v8vqcf1tll', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8v8vqcf1tll', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4b5odospgxg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4b5odospgxg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4b5odospgxg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9gvz8cc0mh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9gvz8cc0mh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9gvz8cc0mh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-iqn3dqlxwt').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-iqn3dqlxwt', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-iqn3dqlxwt', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-avbk8jv1m1').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-avbk8jv1m1', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-avbk8jv1m1', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-61cty7428c').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-61cty7428c', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-61cty7428c', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qtrvj8fxa8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qtrvj8fxa8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qtrvj8fxa8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-avpyaf2hz9q').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-avpyaf2hz9q', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-avpyaf2hz9q', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-plof3wr6dvl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-plof3wr6dvl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-plof3wr6dvl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qd4kc2t05zg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qd4kc2t05zg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qd4kc2t05zg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8lbmdkv1s0q').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8lbmdkv1s0q', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8lbmdkv1s0q', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jwqkhhzl25').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jwqkhhzl25', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jwqkhhzl25', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qwqjrb2yhp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qwqjrb2yhp', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qwqjrb2yhp', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-euz645mxn7k').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-euz645mxn7k', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-euz645mxn7k', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-letblbw8lfh"]=  window.__ectimmers["ecom-letblbw8lfh"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-letblbw8lfh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-letblbw8lfh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-letblbw8lfh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g1hzciztk1c').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g1hzciztk1c', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g1hzciztk1c', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-owmbmpxo3ms').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-owmbmpxo3ms', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-owmbmpxo3ms', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7fxy8qu6yv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7fxy8qu6yv', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7fxy8qu6yv', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qodsqsgoma"]=  window.__ectimmers["ecom-qodsqsgoma"] || {};
const t=this.$el;if(!t)return;const e=t.querySelector("form");let i=this.settings.link_redirect,n=window.location.href,o=this.settings.form_action_after_submit;if(this.isLive){let l=function(){if(!i)return!1;let d=i.href;if(d=="")return!1;let p=i.target;window.location.href.includes("customer_posted=true")&&(p==="_blank"?window.open(d):window.location.href=d)};const s=t.querySelector(".ecom-shopify__newsletter__verify-checkbox"),r=t.querySelector(".ecom-shopify__newsletter__verify-error");if(e&&s){const d=function(p){r&&r.classList.toggle("ecom-dn",!p)};s.addEventListener("invalid",function(p){p.preventDefault(),d(!0)}),e.addEventListener("submit",function(p){s.checked||(p.preventDefault(),p.stopImmediatePropagation(),d(!0))}),s.addEventListener("change",function(){s.checked&&d(!1)})}const a=this.settings.ga4_event_name;if(this.isLive===!0&&e&&a){const d="ecom_nl_ga4_pending",p={form_id:e.id,form_name:this.settings.tracking_id||"newsletter_form",form_destination:"shopify_customer"},m=function(_,b){const y=Object.assign({},p,b||{});typeof window.gtag=="function"&&window.gtag("event",_,y),window.dataLayer&&typeof window.dataLayer.push=="function"&&window.dataLayer.push(Object.assign({event:_},y))};if(e.addEventListener("submit",function(){try{sessionStorage.setItem(d,JSON.stringify({id:e.id,t:new Date().getTime()}))}catch(_){}m("form_submit")}),t.querySelector(".ecom-shopify__newsletter-form-success")){let _=null;try{_=JSON.parse(sessionStorage.getItem(d)||"null")}catch(b){}if(_&&_.id===e.id&&new Date().getTime()-_.t<3e5){try{sessionStorage.removeItem(d)}catch(b){}m(a,{method:"newsletter"})}}}if(o&&o==="popup"){if(n.includes("customer_posted=true")&&e&&e.hasAttribute("data-ecom-popup")){const d=e.getAttribute("data-ecom-popup")||"",p=document.querySelector("#ecom-popup-data");if(!p){console.warn("Ecom popup data element not found");return}const m=JSON.parse(p.innerHTML);if(m){let _=m.find(b=>b.id===d);setTimeout(()=>{_&&window.EComPopup.popupContainerHandler&&window.EComPopup.popupContainerHandler(_)},300)}}return}l();const c=/(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;this.settings.scroll_in_view&&(window.location.pathname.includes("challenge")?setTimeout(function(){var d=document.querySelector(".shopify-challenge__container");d.scrollIntoView()},100):setTimeout(function(){(c.test(location.search)||window.location.href.includes("customer_posted=true"))&&t.scrollIntoView()},300)),c.test(location.search)&&e&&e.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")&&e.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn").classList.remove("ecom-dn"),e&&e.dataset.ecTrackingId&&e.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:e.id,tracking_id:e.dataset.ecTrackingId})},{once:!0})}

                    });
                    
                        document.querySelectorAll('.ecom-qodsqsgoma').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qodsqsgoma', settings: {"form_action_after_submit":"redirect","scroll_in_view":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qodsqsgoma', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0u2j9cccxva').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0u2j9cccxva', settings: {"form_action_after_submit":"redirect","scroll_in_view":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0u2j9cccxva', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-26dajizxvohj"]=  window.__ectimmers["ecom-26dajizxvohj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-26dajizxvohj"]["gf0dossj2"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-26dajizxvohj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-26dajizxvohj', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-26dajizxvohj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1yo2rs91ocn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1yo2rs91ocn', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1yo2rs91ocn', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-89m2a9uu2w7"]=  window.__ectimmers["ecom-89m2a9uu2w7"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-89m2a9uu2w7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-89m2a9uu2w7', settings: {"disable_auto_close":false,"disable_effect":true,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-89m2a9uu2w7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9mrq91qluvf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9mrq91qluvf', settings: {"disable_auto_close":false,"disable_effect":true,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9mrq91qluvf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-b8kvtmem88a').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-b8kvtmem88a', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-b8kvtmem88a', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jvph1qveapq"]=  window.__ectimmers["ecom-jvph1qveapq"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{n==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-jvph1qveapq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jvph1qveapq', settings: {"action":"click"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jvph1qveapq', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-10e0uipx64wk"]=  window.__ectimmers["ecom-10e0uipx64wk"] || {};
const t=this.$el,e=this.isLive,i=t.querySelector(".ecom-countdown-date-warning");if(i&&i.remove(),!!window.EComCountdown&&window.EComCountdown){let S=function(E,I,j){let M="expires="+j.toUTCString();document.cookie=E+"="+I+";"+M+";path=/"},C=function(E){let I=E+"=",M=decodeURIComponent(document.cookie).split(";");for(let D=0;D<M.length;D++){let T=M[D];for(;T.charAt(0)==" ";)T=T.substring(1);if(T.indexOf(I)==0)return T.substring(I.length,T.length)}return""},x=function(E){const[I,j,M]=E.split(":"),D=I*24*60*60*1e3,T=j*60*60*1e3,F=M*60*1e3;return D+T+F},$=function(E,I,j){let M=C(d),D=M?JSON.parse(M):"";!e||(E==="hideTimer"?I.style.display="none":E==="hideSection"?e&&(I.closest(".ecom-section").style.display="none"):E==="redirect"?j?D!=null&&D.redirect_url&&(window.location.href=D.redirect_url):v&&(window.location.href=v):E==="toast"&&w&&(j?D.messages&&EComposer.showToast(D.messages):EComposer.showToast(w)))};const o=t.querySelector(".ecom-element__countdown--time");let s=t.querySelector(".ecom-countdown-progress-bar"),r=t.querySelector(".ecom-countdown-progress-bar--timer"),a=o?o.dataset.countdownFrom:0,l=o&&o.dataset.countdownType?o.dataset.countdownType:"visit",c=o&&o.dataset.countdownRestart?o.dataset.countdownRestart:!1,d="ecomposer_evergreen",p=C(d);p&&JSON.parse(p);let m=o.dataset.countdownTo;const _=o.dataset.evergreenRestart?JSON.parse(o.dataset.evergreenRestart):"",b=_?_.type:"",y=o.dataset.evergreenExpiryActions?o.dataset.evergreenExpiryActions:"",v=o.dataset.evergreenRedirectUrl?o.dataset.evergreenRedirectUrl:"",w=o.dataset.evergreenActionMessages?o.dataset.evergreenActionMessages:"";if(o&&o.dataset.evergreenCdTime&&o.dataset.countdownType==="evergreen"){const E=new Date().getTime();m=new Date(E+x(o.dataset.evergreenCdTime))}if(o&&m){let M=function(D){if(this.innerHTML=D.strftime(n),s&&a){let T=new Date().getTime(),F=new Date(a),H=F.getTime(),R=D.finalDate.getTime();if(H<T&&R>H){s.style.display="inherit";let K=R-H,W=R-T,G=Math.round(W*100/K);r.style.width=G+"%"}else s.style.display="none"}};const E=o.dataset.showFields?o.dataset.showFields:"",I=o.dataset;var n="";const j=/\[([^\]]+)\]/gm;if(E.includes("week")&&I.transWeek.length>0){let D="",T=I.transWeek.replace(j,(...F)=>(D=F[1],""));n+=`
                                        <div class="ecom-element__countdown-item--weeks">
                                            <span class="ecom-element__countdown-number">${D}</span>
                                            <span class="ecom-element__countdown-text">
                                                 ${T}
                                            </span>
                                        </div>`}if(E.includes("day")&&I.transDay.length>0){let D="",T=I.transDay.replace(j,(...F)=>(D=F[1],""));n+=`
                                        <div class="ecom-element__countdown-item--days">
                                            <span class="ecom-element__countdown-number">
                                                ${D}
                                            </span>
                                            <span class="ecom-element__countdown-text">
                                                ${T}
                                            </span>
                                        </div>`}if(E.includes("hour")&&I.transHour.length>0){let D="",T=I.transHour.replace(j,(...F)=>(D=F[1],""));n+=`
                                        <div class="ecom-element__countdown-item--hours">
                                            <span class="ecom-element__countdown-number">
                                                 ${D}
                                            </span>
                                            <span class="ecom-element__countdown-text">
                                                ${T}
                                            </span>
                                        </div>`}if(E.includes("minute")&&I.transMinute.length>0){let D="",T=I.transMinute.replace(j,(...F)=>(D=F[1],""));n+=`
                                        <div class="ecom-element__countdown-item--minutes">
                                            <span class="ecom-element__countdown-number">
                                                ${D}
                                            </span>
                                            <span class="ecom-element__countdown-text">
                                                ${T}
                                            </span>
                                        </div>`}if(E.includes("second")&&I.transSecond.length>0){let D="",T=I.transSecond.replace(j,(...F)=>(D=F[1],""));n+=`
                                        <div class="ecom-element__countdown-item--seconds">
                                            <span class="ecom-element__countdown-number">
                                                ${D}
                                            </span>
                                            <span class="ecom-element__countdown-text">
                                                ${T}
                                            </span>
                                    </div>`}if(!(a&&new Date().getTime()<new Date(a).getTime()&&l=="time")){let D=new Date(m);if(!e&&l!=="evergreen"&&D<new Date){const T=document.createElement("div");T.className="ecom-countdown-date-warning",T.style.cssText="position:absolute;inset:0;background:rgba(251,191,36,.1);border:2px dashed #f59e0b;display:flex;align-items:center;justify-content:center;z-index:10;pointer-events:none;font-size:13px;color:#b45309;font-weight:600;text-align:center;padding:8px;border-radius:4px;box-sizing:border-box;",T.textContent="\u26A0 Countdown date has expired. Please update to a future date.",t.style.position="relative",t.appendChild(T)}if(window.EComCountdown){if(l==="evergreen"){let H=C(d),R=H?JSON.parse(H):"";if(b!=="nextVisit"&&b!=="immediately"){const K=o.dataset.evergreenVersion?o.dataset.evergreenVersion:"";let W={action:o.dataset.evergreenExpiryActions?o.dataset.evergreenExpiryActions:"",evergreen_ver:K,creation_date:new Date,countdown_time:m,expiration_date:"",redirect_url:v,messages:w};if(typeof R=="object"&&R.evergreen_ver&&R.evergreen_ver===K){let G=new Date,se=new Date(R.countdown_time);if(se>G)D=se,a=R.creation_date?R.creation_date:0;else{t.style.display="none",$(R.action,t,!0);return}}else if(b==="specificTime"){const G=new Date;a=G;let se=typeof x(_.data)=="number"?new Date(G.getTime()+x(_.data)):0;W.expiration_date=se,S(d,JSON.stringify(W),se)}else if(b==="none"){const G=new Date;a=G;let se=new Date(G);se.setDate(G.getDate()+365),W.expiration_date=se,S(d,JSON.stringify(W),se)}}else a=new Date}let T=new Date(m).getTime()-new Date(o.dataset.countdownFrom).getTime(),F=new Date(m).getTime()+T;if(T==0)return;for(;F<new Date().getTime();)F+=T;window.EComCountdown(o,D,{}),o.addEventListener("update.ecom.countdown",M),o.addEventListener("finish.ecom.countdown",function(H){if(c=="true"&&l=="time"&&window.EComCountdown(o,new Date(F),M),l==="evergreen")if(b==="none"||b==="specificTime"){let R=C(d),K=R?JSON.parse(R):"";$(K.action,t,!0)}else if(b==="immediately"&&_.data){let R=x(o.dataset.evergreenCdTime);if(typeof R=="number"&&R>0){let K=new Date().getTime();a=new Date,$(y,t),window.EComCountdown(o,new Date(K+R),M)}}else b==="nextVisit"&&$(y,t)})}}}}

                    });
                    
                        document.querySelectorAll('.ecom-10e0uipx64wk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-10e0uipx64wk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-10e0uipx64wk', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-di1hdnzengr"]=  window.__ectimmers["ecom-di1hdnzengr"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-di1hdnzengr"]["1wsel31oz"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-di1hdnzengr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-di1hdnzengr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-di1hdnzengr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g8h9wbb99i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g8h9wbb99i', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g8h9wbb99i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-tmzn4t4fbw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-tmzn4t4fbw', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-tmzn4t4fbw', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qa9az2ufwd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qa9az2ufwd', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qa9az2ufwd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5eypeu8uhur').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5eypeu8uhur', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5eypeu8uhur', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-c26m55e91t').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-c26m55e91t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-c26m55e91t', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}